<script setup lang="ts">

import type NewsItem from '@/types/NewsItem.ts'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import StyledImage from '@/components/Elements/Images/StyledImage.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  itemImage: string,
  newsItem: NewsItem,
  header: string,
  imageBg?: string
}>();

const title = computed (() => {
  return '<div class="flex justify-between"><div class="overflow-hidden text-ellipsis whitespace-nowrap">' + props.header + '</div><div class="px-2">' + status.value + '</div></div>'
})

const status = computed (() => {
  if(props.newsItem.isRead) {
    return t('common.time.day') + ' ' + props.newsItem.turn
  } else {
    return '<span class="text-red-500">' + t('common.status.new') + '</span>'
  }
})

</script>

<template>
  <StandardCard :title="title" top-padding="0" :no-padding="true">
  <div class="flex flex-row h-36">
    <div class="hidden sm:flex flex-shrink-0 p-2">
      <slot name="image">
        <StyledImage :src="itemImage" size="md" :bg="imageBg" />
      </slot>
    </div>
    <div class="flex-grow p-2 ps-2">
      <slot></slot>
    </div>
  </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>